import { createSelector } from "@reduxjs/toolkit";

import { LabList } from "custom-models/frontLoader";

import { ExternalLabsState } from "reducers/frontLoaderReducers";

export const selectExternalLabsForLab = createSelector(
  [
    (state: { externalLabs: ExternalLabsState }) => state.externalLabs,
    (_state, lab?: LabList) => lab,
  ],

  (externalLabs, lab) => {
    if (!lab) return [];
    return Object.values(externalLabs || {})
      .filter((l) =>
        lab.name === "PW Florida"
          ? l.name.includes("Bayshore") ||
            l.name.includes("Seacoast") ||
            l.name.includes("Bernhardt")
          : lab.name === "PW SLC"
          ? l.name.includes("Intermountain") ||
            l.name.includes("Rocky Mountain") ||
            l.name.includes("Sutton Dermatology") ||
            l.name.includes("Skin Care Doctors")
          : lab.name === "Twin Cities Dermatopathology"
          ? l.name.includes("Sutton Dermatology") ||
            l.name.includes("Skin Care Doctors")
          : lab.name?.includes("Global Pathology")
          ? l.name.includes("Woodruff")
          : lab.name?.includes("New England Tissue Issue")
          ? l.name.includes("Dermatology Associates") ||
            l.name.includes("US Path Labs")
          : lab.name === "ProPath"
          ? l.name.includes("Paducah Dermatology")
          : false
      )
      .sort((a, b) =>
        a.name.localeCompare(b.name, "en", { sensitivity: "base" })
      );
  }
);
